'use strict';

function trustUrl($sce) {
  return function (url) {
    return $sce.trustAsResourceUrl(url);
  };
};
module.exports = trustUrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/filters/trustUrl.js
 ** module id = 26
 ** module chunks = 0
 **/